import { ErrorMessage, Field } from "formik";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormTextAreaField = ({
  label = "textAreaField",
  labelClassName = "",
  name = "textField",
  value = "",
  onChange = () => {},
  className = "",
  placeholder = "",
  type = "text",
  rows = 5,
  required,
  maxLength = null,
  ...props
}) => {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <div className={`flex flex-col gap-1 ${className} w-full`}>
          {label && (
            <label
              htmlFor={name}
              className={`text-fs_14 md:text-fs_16 font-fw_400 capitalize ${
                meta.touched && meta.error ? "text-errorColor" : labelClassName
              }`}
            >
              {formatUnderscoreToSpace(label)}
              {required && <span className="text-red-500"> *</span>}
            </label>
          )}
          <textarea
            {...field}
            id={name}
            name={name}
            type={type}
            // value={value}
            rows={rows}
            placeholder={formatUnderscoreToSpace(placeholder)}
            required={required}
            maxLength={maxLength}
            className={`px-3 py-2 w-full rounded-lg lg:text-fs_16 border-[1px]
              text-fs_14 text-darkText placeholder-greyText placeholder:text-fs_14 md:placeholder:text-fs_16 focus:outline-none resize-none ${
                meta.touched && meta.error
                  ? "border-errorColor"
                  : "border-greyText"
              }`}
          />
          <label className="text-errorColor text-fs_14 ps-1 h-[1rem]">
            <ErrorMessage name={name} />
          </label>
        </div>
      )}
    </Field>
  );
};
